"use client";

import { useState } from "react";
import LoadingButton from "@mui/lab/LoadingButton";
import { Add, Remove, ShoppingCart } from "@mui/icons-material";
import { Button, Box, TextField } from "@mui/material";
import { FlexBox } from "@/components/flex-box";
import useCart from "hooks/useCart";

export default function AddToCart({ product }) {
  const { id, price, discount_price, name, slug, photo, vendor } = product;
  const { addToCart } = useCart();

  const [isLoading, setLoading] = useState(false);
  const [quantity, setQuantity] = useState(1);
  const [added, setAdded] = useState(false);

  const increment = () => setQuantity((prev) => prev + 1);
  const decrement = () => setQuantity((prev) => (prev > 1 ? prev - 1 : 1));

  const handleAddToCart = async () => {
    try {
      setLoading(true);
      const pricef = discount_price === 0 ? price : discount_price;
      await addToCart({ id, slug, price: pricef, name, photo, qty: quantity, vendor }, quantity);
      setAdded(true);
      setTimeout(() => setAdded(false), 1500);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box display="flex" alignItems="center" gap={1.5} flexWrap="wrap">
      {/* Selector de cantidad */}
      <FlexBox
        alignItems="center"
        sx={{
          border: "1px solid",
          borderColor: "grey.300",
          borderRadius: 2,
          overflow: "hidden",
          height: 44,
        }}
      >
        <Button
          size="small"
          color="primary"
          disabled={quantity === 1 || isLoading}
          onClick={decrement}
          sx={{ minWidth: 36, height: "100%", borderRadius: 0, px: 1 }}
        >
          <Remove fontSize="small" />
        </Button>

        <TextField
          type="number"
          value={quantity}
          onChange={(e) => {
            let value = e.target.value;
            if (value.length > 1 && value.startsWith("0")) value = value.replace(/^0+/, "");
            const numValue = value ? Number(value) : "";
            if (numValue === "" || numValue >= 1) setQuantity(numValue);
          }}
          onBlur={() => { if (!quantity || quantity < 1) setQuantity(1); }}
          inputProps={{ min: 1, style: { textAlign: "center", padding: 0 } }}
          variant="standard"
          sx={{
            width: 40,
            "& .MuiInput-root": { "&:before": { display: "none" }, "&:after": { display: "none" } },
            "& input": {
              textAlign: "center",
              fontWeight: 600,
              fontSize: 15,
              "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
                WebkitAppearance: "none",
                margin: 0,
              },
              MozAppearance: "textfield",
            },
          }}
          disabled={isLoading}
        />

        <Button
          size="small"
          color="primary"
          onClick={increment}
          disabled={isLoading}
          sx={{ minWidth: 36, height: "100%", borderRadius: 0, px: 1 }}
        >
          <Add fontSize="small" />
        </Button>
      </FlexBox>

      {/* Botón añadir al carrito */}
      <LoadingButton
        color={added ? "success" : "primary"}
        variant="contained"
        loading={isLoading}
        loadingPosition="start"
        startIcon={!isLoading && <ShoppingCart />}
        onClick={handleAddToCart}
        sx={{
          textTransform: "none",
          px: 3,
          height: 44,
          fontSize: 15,
          fontWeight: 600,
          borderRadius: 2,
          flex: 1,
          minWidth: 160,
          transition: "all 0.3s ease",
        }}
      >
        {added ? "Añadido ✓" : "Añadir al carrito"}
      </LoadingButton>
    </Box>
  );
}
